module.exports = __webpack_public_path__ + "img/h4.df309049.jpg";